<template>
  <div class="home">
    <hero-component />
    <div class="home__categories">
      <div
          class="home__categories-item"
      >
        <img src="@images/bundlesImage.png" alt="image">
        <router-link
            :to="translations.i18nRoute({ name: 'store', params: { category: t('home.categories.bundles') } })"
        >
          <p>{{ t('home.categories.bundles') }}</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="8" viewBox="0 0 21 8" fill="none">
            <path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4V4.5H20V4V3.5H0V4Z" fill="currentColor"/>
          </svg>
        </router-link>
      </div>
      <div
          class="home__categories-item"
      >
        <img src="@images/scriptsImage.png" alt="image">
        <router-link
            :to="translations.i18nRoute({ name: 'store', params: { category: t('home.categories.scripts') } })"
        >
          <p>{{ t('home.categories.scripts') }}</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="8" viewBox="0 0 21 8" fill="none">
            <path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4V4.5H20V4V3.5H0V4Z" fill="currentColor"/>
          </svg>
        </router-link>
      </div>
      <div
          class="home__categories-item"
      >
        <img src="@images/templatesImage.png" alt="image">
        <router-link
            :to="translations.i18nRoute({ name: 'store', params: { category: t('home.categories.templates') } })"
        >
          <p>{{ t('home.categories.templates') }}</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="8" viewBox="0 0 21 8" fill="none">
            <path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4V4.5H20V4V3.5H0V4Z" fill="currentColor"/>
          </svg>
        </router-link>
      </div>
    </div>
    <popular-component />
    <better-component />
    <why-component />
  </div>
</template>

<script setup>
import HeroComponent from "@/components/home/hero-component.vue";
import PopularComponent from "@/components/home/popular-component.vue";
import BetterComponent from "@/components/home/better-component.vue";
import WhyComponent from "@/components/home/why-component.vue";
import {computed, onMounted} from "vue";
import {useRoute} from "vue-router";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";

const route = useRoute()
const {t} = useI18n()

const uid = computed(() =>
  route.query.uid ? (route.query.uid) : undefined,
);
const token = computed(() =>
  route.query.token ? (route.query.token) : undefined,
);

const activateUser = async () => {
  const res = await Auth.activateUser(token.value, uid.value);

  if (res.data.activateUser) {
    ElNotification({
      message: t('popup.activateSuccess'),
      type: 'success'
    })
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }
}

onMounted( async () => {
  if (route.name === 'activate-user') {
    await activateUser()
  }

  if (route.name === 'payment') {
    ElNotification({
      message: t('popup.payment'),
      type: "success"
    });
  }
})
</script>

<style lang="scss" scoped>
.home {
  overflow-x: hidden;
  top: -103px;

  &__categories {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: -5px;

    &-item {
      position: relative;
      border-radius: 63px 63px 0 0;
      overflow: hidden;

      & img {
        width: 100%;
      }

      & a {
        cursor: pointer;
        position: absolute;
        left: 20px;
        bottom: 20px;
        border-radius: 12px 30px 30px 12px;
        border: 0.5px solid #2B3044;
        background-color: $white;
        box-shadow: 0 0 11.6px 0 rgba(0, 0, 0, 0.20);
        display: flex;
        align-items: center;
        gap: 25px;
        padding: 5px 30px;
        transition: 0.2s;

        text-transform: capitalize;
        color: #2B3044;
        text-align: center;
        font-family: "Hanken Grotesk", sans-serif;
        font-size: 20px;
        font-weight: 500;

        &:hover {
          background-color: #2B3044;
          color: $white;
        }
      }

      &:first-child {
        border-radius: 0 63px 0 0;
      }

      &:last-child {
        border-radius: 63px 0 0 0;
      }
    }
  }
}

@media (max-width: 750px) {
  .home {
    &__categories {
      &-item {
        border-radius: 20px 20px 0 0;

        &:first-child {
          border-radius: 0 20px 0 0;
        }

        &:last-child {
          border-radius: 20px 0 0 0;
        }

        & a {
          left: 10px;
          bottom: 10px;
          padding-inline: 15px;
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .home {
    &__categories {
      grid-template-columns: 1fr;
      gap: 10px;

      &-item {
        border-radius: 0 !important;
        height: 200px;

        & img {
          object-fit: cover;
          height: 100%;
        }
      }
    }
  }
}
</style>